import { getAbsoluteSpaUrl } from './pathUtils';

/**
 * OpenAPI Schema Parser für die Extraktion von Feldconstraints
 */
export class OpenApiSchemaParser {
    private static schema: any = null;

    /**
     * Lädt das OpenAPI Schema aus der JSON-Datei
     */
    static async loadSchema(): Promise<void> {
        if (this.schema) return;

        const response = await fetch(getAbsoluteSpaUrl('openapi.json'));
        this.schema = await response.json();
    }

    /**
     * Ermittelt die maximale Länge für ein bestimmtes Feld in einem Schema
     */
    static getFieldMaxLength(schemaName: string, fieldName: string): number | undefined {
        return this.schema?.components?.schemas?.[schemaName]?.properties?.[fieldName]?.maxLength;
    }

    /**
     * Ermittelt alle maxLength-Constraints für ein Schema
     */
    static getAllMaxLengthConstraints(schemaName: string): Record<string, number> {
        const schemaDefinition = this.schema?.components?.schemas?.[schemaName];
        const constraints: Record<string, number> = {};

        for (const [fieldName, fieldDefinition] of Object.entries(schemaDefinition.properties)) {
            const maxLength = (fieldDefinition as any)?.maxLength;
            if (maxLength) {
                constraints[fieldName] = maxLength;
            }
        }

        return constraints;
    }
}
